import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledContactsFilter = styled.div`
  background: ${colors.white};
  padding: 20px;
  direction: rtl;
  position: sticky;
  bottom: 0;
  z-index: 10;
  border-top: 0.5px solid #7e8aad4d;
  backdrop-filter: blur(4px);
  margin-top: 20px;
  padding-bottom: 90px;

  .filter-container {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    @media (max-width: 768px) {
      max-width: 100%;
      padding: 0 10px;
    }
  }

  .search-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 768px) {
    .filter-button {
      -webkit-appearance: none;
      -webkit-tap-highlight-color: transparent !important;

      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }

      &:active {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }

  .filter-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 7px;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }

    .filter-button {
      font-size: 14px;
      line-height: 14px;
      color: ${colors.darkBlue};
      cursor: pointer;
      height: 30px;
      border-radius: 70px;
      background-color: ${colors.lightGray};
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 12px;
      outline: none;
      -webkit-tap-highlight-color: transparent;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      flex-shrink: 0;
      min-width: 0;

      @media (max-width: 768px) {
        font-size: 13px;
        padding: 0 10px;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &:focus {
        outline: none;
      }

      &:active {
        outline: none;
      }

      &.active {
        background-color: ${colors.blue};
        color: ${colors.white};
      }

      img {
        width: 14px;
        height: auto;
        object-fit: contain;
        margin-right: 8px;
        flex-shrink: 0;

        @media (max-width: 768px) {
          width: 12px;
          margin-right: 6px;
        }
      }
    }

    .campaign-filter-container {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .month-filter-container {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.darkBlue};
  font-family: "Noto Sans Hebrew", sans-serif;
  white-space: nowrap;
  min-width: fit-content;

  @media (max-width: 768px) {
    text-align: right;
  }
`;

export const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .date-input-container {
    position: relative;
    display: inline-block;
    flex: 1;
    min-width: 0;
  }

  .date-placeholder {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 14px;
    color: ${colors.darkBlue};
    font-family: "Noto Sans Hebrew", sans-serif;
    pointer-events: none;
    z-index: 3;
    transition: opacity 0.2s ease;
  }

  .date-input-container:focus-within .date-placeholder {
    opacity: 0;
  }

  .date-display-text {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 14px;
    color: ${colors.darkBlue};
    font-family: "Noto Sans Hebrew", sans-serif;
    pointer-events: none;
    z-index: 3;
    white-space: nowrap;
    max-width: calc(100% - 24px);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .date-input-container:has(.active) .date-display-text {
    color: ${colors.white};
  }

  span {
    font-size: 14px;
    color: ${colors.blueGray};
    font-family: "Noto Sans Hebrew", sans-serif;
  }
`;

export const DateInput = styled.input`
  font-size: 14px;
  line-height: 14px;
  color: transparent;
  cursor: pointer;
  height: 30px;
  border-radius: 70px;
  background-color: ${colors.lightGray};
  border: none;
  padding: 0 12px;
  font-family: "Noto Sans Hebrew", sans-serif;
  width: 100%;
  position: relative;
  z-index: 1;

  &.active {
    background-color: ${colors.blue};
    color: ${colors.white};
  }

  &:focus {
    outline: none;
    border: 2px solid ${colors.blue};
  }

  /* Hide the default date input styling when empty */
  &::-webkit-datetime-edit {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-text {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-month-field {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-day-field {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-year-field {
    color: transparent;
    opacity: 0;
  }

  &::-webkit-datetime-edit-fields-wrapper {
    opacity: 0;
  }

  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    margin: 0;
    z-index: 2;
  }

  /* Keep date input hidden even when selected - we show custom Hebrew text instead */
  &:not([value=""]) {
    color: transparent;

    &.active {
      color: transparent;
    }

    &::-webkit-datetime-edit {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-text {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-month-field {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-day-field {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-year-field {
      color: transparent;
      opacity: 0;
    }

    &::-webkit-datetime-edit-fields-wrapper {
      opacity: 0;
    }
  }

  @media (max-width: 768px) {
    min-width: 90px;
    padding: 0 10px;
  }
`;

export const FilterCount = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${colors.blueGray};
  font-family: "Noto Sans Hebrew", sans-serif;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${colors.lightBlueGray};
`;

export const CampaignDropdown = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightBlueGray};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  min-width: 150px;
  min-height: 200px;
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 4px;
  direction: rtl;

  @media (max-width: 768px) {
    max-width: calc(100vw - 40px);
    left: 0;
    right: auto;
    transform: none;
  }

  &::-webkit-scrollbar {
    width: 6px;

    &-track {
      background: ${colors.gray};
      border-radius: 3px;
    }

    &-thumb {
      background: ${colors.blueGray};
      border-radius: 3px;
    }
  }
`;

export const SourceDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightBlueGray};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  min-width: 150px;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
  direction: rtl;

  @media (max-width: 768px) {
    max-width: calc(100vw - 40px);
    left: 0;
    right: auto;
    transform: none;
  }

  &::-webkit-scrollbar {
    width: 6px;

    &-track {
      background: ${colors.gray};
      border-radius: 3px;
    }

    &-thumb {
      background: ${colors.blueGray};
      border-radius: 3px;
    }
  }
`;

export const CampaignOption = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
  color: ${colors.darkBlue};
  text-align: right;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 8px 12px;
  }

  &:hover {
    background-color: ${colors.lightBlueGrayBackground};
  }

  &.selected {
    background-color: ${colors.lightBlueGrayBackground};
    font-weight: bold;
    border-left: 3px solid ${colors.blue};
  }

  &.clear-option {
    color: ${colors.blueGray};
    font-style: italic;
    border-bottom: 1px solid ${colors.lightBlueGray};

    &:hover {
      background-color: ${colors.lightGray};
      color: ${colors.darkBlue};
    }
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;

// New styles for the single row layout
export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    gap: 8px;
    flex-wrap: nowrap;
  }
`;

export const SearchInputContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  justify-content: flex-start;

  svg {
    position: absolute;
    left: 14px;
    z-index: 1;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    svg {
      left: 10px;
    }
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  height: 30px;
  border-radius: 20px;
  font-size: 14px;
  font-family: "Noto Sans Hebrew", sans-serif;
  color: ${colors.darkBlue};
  background-color: ${colors.lightGray};
  direction: rtl;
  text-align: right;
  outline: none;
  transition: all 0.2s ease;
  min-width: 0;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 14px;

  &::placeholder {
    color: ${colors.blueGray};
    font-size: 14px;
  }

  @media (max-width: 768px) {
    height: 30px;
    padding: 0 12px;
    font-size: 13px;
    min-width: 120px;
  }
`;

export const FilterButtonContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 10px 0 12px;
  border-radius: 68px;
  font-size: 14px;
  line-height: 14px;
  font-family: "Noto Sans Hebrew", sans-serif;
  border: none;
  position: relative;
  direction: rtl;
  color: ${colors.darkBlue};
  cursor: pointer;
  transition: all 0.2s ease;
  height: 30px;
  white-space: nowrap;
  background-color: ${colors.lightGray};

  &:focus:not(:focus-visible) {
    outline: none;
  }

  img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    padding: 0 14px;
    height: 30px;
    font-size: 13px;
    min-width: 80px;
  }
`;

export const FilterCountBadge = styled.span`
  background-color: ${colors.white};
  color: ${colors.blue};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  border: 2px solid ${colors.blue};
  margin-right: 4px;
`;
